// Unpublished Work (c) 2023-2024 Deere & Company.

export interface IPromotion {
  id: string;
  description: string;
  type: string;
  shipFromDate: string | null;
  shipToDate: string | null;
  startDate: string | null;
  endDate: string | null;
  attachments: string;
  parts: string;
  accountId?: string;
  allParts?: boolean;
}

export interface PartDetails {
  id: string;
  description: string;
  discount: {
    type: string;
    method: "% off Price" | "Amt. off Price" | "Fixed Price";
    value: number;
    criteria: {
      minimumOrderLineValue: number | null;
      maximumOrderLineValue: number | null;
    };
  };
  currency: string;
}

export interface NewPartDetails {
  id: string;
  description: string;
  discount: {
    type: string;
    method: "% off Price" | "Amt. off Price" | "Fixed Price";
    fixedValue: number;
    minimumValue: number;
    maximumValue: number;
    value?: number;
    criteria: {
      minimumOrderLineValue: number;
      maximumOrderLineValue: number;
      fixedOrderLineValue: number;
      type: string | null;
      unitOfMeasure: string | null;
      scaleValue?: string | null;
      scaleAmount?: string | null;
      scaleUom?: string | null;
      discountCurrency?: string | null;
    };
  };
  currency: string;
}

export interface Attachment {
  fileData: string;
  mimeType: string;
  tradePromotionUrl: string;
  tradePromotionUrlDescription: string;
}

export enum Environment {
  DEVL = "devl",
  CERT = "cert",
  QUAL = "qual",
  PROD = "prod",
}

export const dayJSLang: { [key: string]: string } = {
  en_US: "en",
  pt_BR: "pt-br",
  es_MX: "es-mx",
  zh_CN: "zh-cn",
  fr_CA: "fr-ca",
  de_DE: "de",
  it_IT: "it",
  pl_PL: "pl",
};

export const commonDateFormat = "DD-MMM-YYYY";
